<template>
  <div id="detail-wrap2">
    <a class="close_btn" @click.prevent="back">
      <span>
        <i class="el-icon-close"></i>
      </span>
    </a>

    <div class="scroll_area" id="js_modal">
      <div class="head_data">
        {{ contract.id }} - {{ contract.surname }} {{ contract.name }}（{{ contract.surname_kana }}
        {{ contract.name_kana }}）
        <span class="badge">{{ contract.contract_status_name }}</span>
      </div>

      <div class="change_wrap" v-if="Object.keys(editProductInputFieldes).length">
        <SegmentName>商品情報のご入力</SegmentName>
        <div class="table_block">
          <table>
            <tbody>
              <TableTr v-show="editProductInputFieldes.product.isShow">
                <TableTh>{{ editProductInputFieldes.product.label }}</TableTh>
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap">
                    <el-col :span="7">
                      <el-select
                        v-model="form.product"
                        :name="editProductInputFieldes.product.key"
                        @change="onChangeProduct()"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in products"
                          :key="index"
                          :value="item.id"
                          :label="item.name"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="7">
                      <el-input
                        v-model="form.product_other_name"
                        :disabled="!selectedProductName.includes('その他')"
                        :id="editProductInputFieldes.productOtherName.key"
                      ></el-input>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-product_other_name-required_if"></ErrorMessage>
                  <ErrorMessage class="error-product_other_name-string"></ErrorMessage>
                  <ErrorMessage class="error-product_other_name-maxlen"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.serviceStartDate.isShow && form.product">
                <TableTh>{{ editProductInputFieldes.serviceStartDate.label }}</TableTh>
                <td>
                  <el-date-picker
                    type="date"
                    :clearable="true"
                    :editable="false"
                    :placeholder="editProductInputFieldes.serviceStartDate.label"
                    format="yyyy年MM月dd日"
                    v-model="form.service_start_date"
                    :id="editProductInputFieldes.serviceStartDate.key"
                    :disabled="!form.product"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                  <ErrorMessage class="error-service_start_date-date"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.serviceEndDate.isShow && form.product">
                <TableTh>{{ editProductInputFieldes.serviceEndDate.label }}</TableTh>
                <td>
                  <el-date-picker
                    type="date"
                    :clearable="true"
                    :editable="false"
                    :placeholder="editProductInputFieldes.serviceEndDate.label"
                    format="yyyy年MM月dd日"
                    v-model="form.service_end_date"
                    :id="editProductInputFieldes.serviceEndDate.key"
                    :disabled="!form.product"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                  <ErrorMessage class="error-service_end_date-date"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.cashTotal.label }}<span class="require">必須</span></TableTh>
                <td>
                  <el-input
                    type="tel"
                    v-model="form.cash_total"
                    @blur="isComma('cash_total')"
                    @focus="
                      zeroDelete('cash_total')
                      noneComma('cash_total')
                    "
                    @input="updateRemainigMoney('cash_total')"
                    placeholder="金額"
                    class="price_input"
                    id="cash_total"
                  >
                    <span slot="suffix">円</span>
                  </el-input>
                  <ErrorMessage class="error-cash_total-required"></ErrorMessage>
                  <ErrorMessage class="error-cash_total-integer"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.downPayment.label }}<span class="require">必須</span></TableTh>
                <td>
                  <el-input
                    type="tel"
                    v-model="form.down_payment"
                    @blur="isComma('down_payment')"
                    @focus="
                      zeroDelete('down_payment')
                      noneComma('down_payment')
                    "
                    @input="updateRemainigMoney('down_payment')"
                    placeholder="金額"
                    class="price_input"
                    id="down_payment"
                  >
                    <span slot="suffix">円</span>
                  </el-input>
                  <ErrorMessage class="error-down_payment-required"></ErrorMessage>
                  <ErrorMessage class="error-down_payment-integer"></ErrorMessage>
                  <ErrorMessage class="error-down_payment-lt"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>
        </div>
        <SegmentName>お支払い方法のご入力</SegmentName>
        <div class="table_block">
          <table>
            <tbody>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.remainingMoney.label }}</TableTh>
                <td>
                  {{ form.remaining_money | isComma }} 円
                  <ErrorMessage class="error-remaining_money-required" :validation="false"></ErrorMessage>
                  <!-- 下記inputはバリデーション用 -->
                  <input id="remaining_money" type="numberr" :value="form.remaining_money" class="d-none" />
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.bonusFee.isShow">
                <TableTh>{{ editProductInputFieldes.bonusFee.label }}</TableTh>
                <td>
                  <span id="bonus_total_fee">{{ form.split_fee | isComma }} </span>
                  円 <span class="fz-12 text-danger"></span>
                  <ErrorMessage class="error-split_fee-required_if" :validation="false"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.splitFee.isShow">
                <TableTh>{{ editProductInputFieldes.splitFee.label }}</TableTh>
                <td>
                  <span id="split_total_fee">{{ form.split_fee | isComma }} </span>
                  円 <span class="fz-12 text-danger"></span>
                  <ErrorMessage class="error-split_fee-required_if" :validation="false"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.splitTotalPayment.isShow">
                <TableTh>{{ editProductInputFieldes.splitTotalPayment.label }}</TableTh>
                <td>
                  <span id="split_total_pay">{{ form.split_total_payment | isComma }} </span>
                  円 <span class="fz-12 text-danger"></span>
                  <ErrorMessage class="error-split_total_payment-required_if" :validation="false"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.totalPay.label }}</TableTh>
                <td>
                  <span id="total_pay">{{ form.total_pay | isComma }} </span>
                  円
                  <span class="fz-12 text-danger"></span>
                  <ErrorMessage class="error-total_pay-required" :validation="false"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.payment.label }}<span class="require">必須</span></TableTh>
                <td>
                  <el-select
                    id="finance_category_name"
                    class="select--w250"
                    v-model="form.finance_category_name"
                    @change="onChangeFinanceCategoryName($event)"
                    placeholder="金融カテゴリーを選択"
                  >
                    <el-option
                      v-for="(item, index) in finances"
                      :key="`finance_category_name_${index}`"
                      :value="item.category_name"
                      :label="item.category_name"
                    ></el-option>
                  </el-select>
                  <el-select
                    id="payment"
                    class="select--w250"
                    v-model="form.payment"
                    @change="changePayment($event)"
                    placeholder="お支払い方法を選択"
                  >
                    <template v-for="(item, index) in editProductInputFieldes.payment.choices">
                      <el-option
                        :key="`payment_${index}`"
                        :value="item.value"
                        :label="item.label"
                        v-if="item.isShow"
                      ></el-option>
                    </template>
                  </el-select>
                  <ErrorMessage class="error-payment-required"></ErrorMessage>
                  <ErrorMessage class="error-finance_category_name-required"></ErrorMessage>
                  <ErrorMessage class="error-finance_category_name-string"></ErrorMessage>
                  <ErrorMessage class="error-finance_category_name-exists"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>

          <table class="payment_form">
            <tbody>
              <TableTr>
                <td colspan="2" class="payment_style_title" v-show="form.payment">
                  {{ PayTypeText[form.payment] }}
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.splitNumber.isShow">
                <TableTh>{{ editProductInputFieldes.splitNumber.label }}<span class="require">必須</span></TableTh>
                <td>
                  <el-autocomplete
                    name="split_number"
                    popper-class="my-autocomplete"
                    class="price_input"
                    v-model="form.split_number"
                    :fetch-suggestions="querySearchSplitNumber"
                    placeholder="回数"
                    @input="updateSplitNumber"
                  >
                    <span slot="suffix">回</span>
                    <template slot-scope="{item}">
                      <div class="value">
                        {{ item.label }}
                      </div>
                    </template>
                  </el-autocomplete>
                  <FormNotice class="mt-1">半角数字で入力してください。</FormNotice>
                  <ErrorMessage class="error-split_number-required_if"></ErrorMessage>
                  <ErrorMessage class="error-split_number-between"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.bonusCombinedAdditionAmount.isShow">
                <TableTh
                  >{{ editProductInputFieldes.bonusCombinedAdditionAmount.label
                  }}<span class="require">必須</span></TableTh
                >
                <td>
                  <el-input
                    type="tel"
                    v-model="form.bonus_combined_addition_amount"
                    @blur="isComma('bonus_combined_addition_amount')"
                    @focus="
                      zeroDelete('bonus_combined_addition_amount')
                      noneComma('bonus_combined_addition_amount')
                    "
                    @input="simlation()"
                    placeholder="金額"
                    class="price_input"
                    id="bonus_combined_addition_amount"
                  >
                    <span slot="suffix">円</span>
                  </el-input>
                  <ErrorMessage class="error-bonus_combined_addition_amount-required_if"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.bonusCombinedMonth.isShow">
                <TableTh
                  >{{ editProductInputFieldes.bonusCombinedMonth.label }}<span class="require">必須</span></TableTh
                >
                <td>
                  <el-row :gutter="10" type="flex" align="middle" class="flex-wrap">
                    <el-col class="u-w--auto">{{
                      editProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth1.label
                    }}</el-col>
                    <el-col :span="5">
                      <el-select
                        class="select--w250"
                        v-model="form.bonus_combined_month1"
                        :placeholder="editProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth1.label"
                        @change="
                          simlation()
                          ignitionEvent('change', 'bonus_combined_month1')
                          ignitionEvent('change', 'bonus_combined_month2')
                        "
                        id="bonus_combined_month1"
                      >
                        <el-option
                          v-for="(item, index) in editProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth1
                            .choices"
                          :key="`bonusCombinedMonth1_${index}`"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col class="u-w--auto">{{
                      editProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth2.label
                    }}</el-col>
                    <el-col :span="5">
                      <el-select
                        class="select--w250"
                        v-model="form.bonus_combined_month2"
                        :placeholder="editProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth2.label"
                        @change="
                          simlation()
                          ignitionEvent('change', 'bonus_combined_month2')
                          ignitionEvent('change', 'bonus_combined_month1')
                        "
                        id="bonus_combined_month2"
                      >
                        <el-option
                          v-for="(item, index) in editProductInputFieldes.bonusCombinedMonth.bonusCombinedMonth2
                            .choices"
                          :key="`bonusCombinedMonth1_${index}`"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </el-row>
                  <ErrorMessage class="error-bonus_combined_month-required_if"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.bonusCombinedNumber.isShow">
                <TableTh>{{ editProductInputFieldes.bonusCombinedNumber.label }}</TableTh>
                <td>
                  <span id="split_first_pay">{{ form.bonus_combined_number }} </span>
                  回
                  <input type="text" id="bonus_combined_payment" class="d-none" />
                  <ErrorMessage class="error-bonus_combined_addition_amount-unit"></ErrorMessage>
                  <ErrorMessage class="error-bonus_combined_payment-percent"></ErrorMessage>
                  <ErrorMessage class="error-bonus_combined_number-required_if" :validation="false"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.bonusOnceMonth.isShow">
                <TableTh>{{ editProductInputFieldes.bonusOnceMonth.label }}<span class="require">必須</span></TableTh>
                <td>
                  <el-select
                    class="select--w250"
                    v-model="form.bonus_once_month"
                    :placeholder="editProductInputFieldes.bonusOnceMonth.label"
                    @change="
                      updateBonusSecondMonth()
                      ignitionEvent('change', 'bonus_once_month')
                    "
                    name="bonus_once_month"
                  >
                    <el-option
                      v-for="(item, index) in getBonusOnceMonthChoices"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>

                  <el-button @click="() => {
                    fixBonusMonth = !fixBonusMonth 
                    firstLoadFlg = false
                  }" :disabled="!options.setting_bonus_fixed_month"
                    >修正</el-button
                  >
                  <ErrorMessage class="error-bonus_once_month-required_if"></ErrorMessage>
                  <ErrorMessage class="error-bonus_once_month-date"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.bonusTwiceMonth.isShow">
                <TableTh>{{ editProductInputFieldes.bonusTwiceMonth.label }}<span class="require">必須</span></TableTh>
                <td>
                  <el-select
                    class="select--w250"
                    v-model="form.bonus_twice_month"
                    :placeholder="editProductInputFieldes.bonusTwiceMonth.label"
                    @change="
                      updatePaymentPeriodStart()
                      ignitionEvent('change', 'bonus_twice_month')
                    "
                    id="bonus_twice_month"
                  >
                    <el-option
                      v-for="(item, index) in getBonusTwiceMonthChoices"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>

                  <el-button @click="() => {
                    fixBonusMonth = !fixBonusMonth 
                    firstLoadFlg = false
                  }" :disabled="!options.setting_bonus_fixed_month"
                    >修正</el-button
                  >
                  <ErrorMessage class="error-bonus_twice_month-required_if"></ErrorMessage>
                  <ErrorMessage class="error-bonus_twice_month-date"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh
                  >{{ editProductInputFieldes.paymentPeriodStart.label }}<span class="require">必須</span></TableTh
                >
                <td>
                  <el-select
                    :placeholder="editProductInputFieldes.paymentPeriodStartY.label"
                    class="select--w120"
                    v-model="formExtends.payment_period_start_y"
                    @change="generatePaymentPeriodStart()"
                    :disabled="isPaymentPeriodStartYDisable"
                  >
                    <el-option
                      v-for="(item, index) in getPaymentPeriodStartYearList()"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                  年
                  <el-select
                    :placeholder="editProductInputFieldes.paymentPeriodStartM.label"
                    class="select--w90"
                    v-model="formExtends.payment_period_start_m"
                    @change="generatePaymentPeriodStart()"
                    :disabled="isPaymentPeriodStartMDisable"
                  >
                    <el-option
                      v-for="(item, index) in editProductInputFieldes.paymentPeriodStartM.choices"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                      :disabled="isPaymentPeriodStartMonthEnable(item)"
                    ></el-option>
                  </el-select>
                  月
                  <el-input type="hidden" v-model="form.payment_period_start" id="payment_period_start"></el-input>

                  <ErrorMessage class="error-payment_period_start-required"></ErrorMessage>
                  <ErrorMessage class="error-payment_period_start-date"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.paymentPeriodEnd.label }}</TableTh>
                <td>
                  <span id="split_first_pay_date">{{ form.payment_period_end | dateFormat('YYYY年MM月') }} </span>
                  <ErrorMessage class="error-payment_period_end-required" :validation="false"></ErrorMessage>
                  <ErrorMessage class="error-payment_period_end-date" :validation="false"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.paymentAmountOnce.label }}</TableTh>
                <td>
                  <el-input
                    type="tel"
                    v-show="form.payment === 'seconds' && fixSecondPayment"
                    v-model="form.payment_amount_once"
                    @blur="() => {
                      isComma('payment_amount_once') 
                      validatePaymentAmountSecond()
                    }"
                    @focus="
                      zeroDelete('payment_amount_once')
                      noneComma('payment_amount_once')
                    "
                    @input="changeSecondPayment"
                    placeholder="金額"
                    class="price_input price_input__left"
                    id="payment_amount_once"
                  >
                    <span slot="suffix">円</span>
                  </el-input>
                  <template v-if="!fixSecondPayment">
                    <span id="split_second_pay">{{ form.payment_amount_once | isComma }} </span>
                    円
                  </template>
                  <el-button v-if="form.payment === 'seconds' && !fixSecondPayment" @click="editSecondPayment"
                    >修正</el-button
                  >
                  <ErrorMessage class="error-payment_amount_once-required" :validation="false"></ErrorMessage>
                  <ErrorMessage class="error-payment_amount_once-limit"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr v-show="editProductInputFieldes.paymentAmountSecond.isShow">
                <TableTh>{{ editProductInputFieldes.paymentAmountSecond.label }}</TableTh>
                <td>
                  <span id="split_second_pay">{{ form.payment_amount_second | isComma }} </span>
                  円
                  <el-input
                    type="hidden"
                    v-model="form.payment_amount_second"
                    placeholder="金額"
                    class="price_input"
                    id="payment_amount_second"
                  >
                  </el-input>
                  <ErrorMessage class="error-payment_amount_second-required_if" :validation="false"></ErrorMessage>
                  <ErrorMessage class="error-payment_amount_second-limit"></ErrorMessage>
                </td>
              </TableTr>
              <TableTr>
                <TableTh>{{ editProductInputFieldes.personCharge.label }}<span class="require">必須</span></TableTh>
                <td>
                  <el-input
                    v-model="form.person_charge"
                    :placeholder="editProductInputFieldes.personCharge.label"
                    id="person_charge"
                  >
                  </el-input>
                  <ErrorMessage class="error-person_charge-required"></ErrorMessage>
                  <ErrorMessage class="error-person_charge-maxlen"></ErrorMessage>
                </td>
              </TableTr>
            </tbody>
          </table>
        </div>
        <div style="padding-bottom: 15px">
          <el-button type="primary" @click="contractUpdate" v-bind:disabled="isUpdateBtnPushed"
            >変更を保存する</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import {splitPay, splitBonusPay, oncePay, secondsPay, monthlyPay} from '@/js/util/simlator'
import {validate, setErrorLaravel, removeError} from '@/js/util/validate/validateFunction'
import {
  ValidationRulesFun,
  ValidationRulesCommon,
  ValidationRulesCredit,
  ValidationRulesInstallment
} from '@/js/util/member/editProductInputValidationRules'
import {editProductInputDataTransformWebApi} from '@/js/util/admin/editProductInputDataTransform'
import * as helper from '@/js/util/helper'
import {PayTypeText} from '@/js/util/constants'
import {startPeriodAddMonth, useNewPaymentStartRule as readUseNewPaymentStartRule} from '@/js/util/paymentStartPeriod'
import {EditProductInputFieldes} from '@/js/util/admin/editProductInputFieldes'
import * as EditProductInputOptionConstants from '@/js/util/admin/editProductInputOptionConstants'
import ErrorMessage from '@/js/components/member/common/Atoms/ErrorMessage'
import SegmentName from '@/js/components/member/common/Atoms/SegmentName'
import TableTh from '@/js/components/member/common/Molecules/TableTh'
import TableTr from '@/js/components/member/common/Molecules/TableTr'
import FormNotice from '@/js/components/member/common/Atoms/FormNotice'
import {Loading} from 'element-ui'
export default {
  components: {
    ErrorMessage,
    SegmentName,
    TableTh,
    TableTr,
    FormNotice
  },
  data() {
    return {
      contract: {},
      has_payment: 'credit',
      editProductInputFieldes: {},
      form: {
        product: null,
        product_other_name: '',
        service_start_date: null,
        service_end_date: null,
        cash_total: null, // 現金価格合計
        down_payment: null, // 頭金
        remaining_money: null, // 残金
        finance_category_name: '通常', // 金融商品のカテゴリー名
        payment: null, // 支払方法
        split_number: '', // 分割回数
        bonus_combined_addition_amount: null, //ボーナス併用加算額
        bonus_combined_month1: null, // ボーナス加算月・夏
        bonus_combined_month2: null, // ボーナス加算月・冬
        bonus_combined_number: null, //ボーナス加算回数
        bonus_once_month: null, // 支払月1回目
        bonus_twice_month: null, //支払月2回目
        payment_period_start: null, // 支払期間 開始
        payment_period_end: null, // 支払期間 終了
        payment_amount_once: null, // 支払金額 第1回目
        payment_amount_second: null, // 支払金額 第2回目以降
        split_fee: null, // 分割手数料
        split_total_payment: null, // 分割支払合計
        total_pay: null, // 支払総額
        person_charge: '' // 担当者
      },
      formExtends: {},
      fixBonusMonth: false, // 自社割賦のみボーナス月を自由に修正できるフラグ
      splitNumberInput: false, // 分割回数を手入力でも入力できるフラグ
      fixSecondPayment: false, // ボーナス２回払いのタイミングで金額調整が可能かどうかのフラグ
      PayTypeText: PayTypeText,
      finances: [], // 金融商品一覧
      options: {}, // 店舗・加盟店の設定項目
      allOptions: [], // 店舗・加盟店の全ての設定項目
      products: [], // 商品一覧,
      isUpdateBtnPushed: false,
      paymentPeriodStartYearList: [],
      isPaymentPeriodStartYDisable: false,
      isPaymentPeriodStartMDisable: false,
      firstLoadFlg: true,      // 初回読み込み時の支払い管理フラグ
      storeFinanceId: null    // 金融商品情報ID(store_finances.id)
    }
  },
  async created() {},
  async mounted() {
    this.contract = await this.getContract()
    this.has_payment = this.contract.has_payment

    this.finances = await this.getFinances()
    this.setStoreFinanceId(this.contract.finance_category_name)
    this.allOptions = await this.getOptions()
    this.setOptions()
    this.products = await this.getProducts()

    this.editProductInputFieldes = EditProductInputFieldes(this.has_payment, this.form, this.getAppDate, this.finances, this.options)
    // バリデーションを定義
    validate(this.returnValidationRules(), true, this.has_payment)

    const form_list = editProductInputDataTransformWebApi(this.contract)
    this.form = this.valueConversion(EditProductInputOptionConstants.Conversions, true, form_list)
    this.form.has_payment = this.has_payment
    // this.form.bonus_once_month = this.form.bonus_once_month ? moment(this.form.bonus_once_month).format('YYYY年MM月') : this.form.bonus_once_month
    // this.form.bonus_twice_month = this.form.bonus_twice_month ? moment(this.form.bonus_twice_month).format('YYYY年MM月') : this.form.bonus_twice_month
    this.splitPaymentPeriodStartYM()
    this.isPaymentPeriodStartYDisable = this.isPaymentPeriodStartFieldDisable()
    this.isPaymentPeriodStartMDisable = this.isPaymentPeriodStartFieldDisable()
  },
  beforeDestroy() {
    // バリデーションを削除
    validate(this.returnValidationRules(), false, this.has_payment)
  },
  computed: {
    // 申込日を定義
    getAppDate() {
      return this.contract ? moment(this.contract.created_at).startOf('day') : moment().startOf('day')
    },
    /**
     * 支払開始月ルール(true: 新 = 翌月基準 / false: 現行 = 翌々月基準)
     *
     * 加盟店の現在設定ではなく契約に焼き込まれた申込時点の値を参照する。
     * 加盟店が設定を変更しても既存契約の支払開始月・ボーナス月の選択肢を変えないため。
     */
    useNewPaymentStartRule() {
      return readUseNewPaymentStartRule(this.contract)
    },
    // 支払開始日のdatepickerのオプション
    getPickerOptions() {
      const self = this
      const options = {
        disabledDate(date) {
          return self.getAppDate.isAfter(date, 'day')
        }
      }
      return options
    },
    /**
     * 支払月1回目の選択肢
     */
    getBonusOnceMonthChoices() {
      if (this.editProductInputFieldes.bonusOnceMonth) {
        // 初期表示時に「YYYY-MM-DD」の表記となってしまうのを防ぐため
        const isExist = this.editProductInputFieldes.bonusOnceMonth.choices.some(x => x.value === this.form.bonus_once_month)
        if (this.fixBonusMonth || (this.firstLoadFlg && !isExist)) {
          return this.editProductInputFieldes.bonusOnceMonth.fixChoices
        } else {
          return this.editProductInputFieldes.bonusOnceMonth.choices
        }
      } else {
        return []
      }
    },
    /**
     * ボーナス二回の第2回目支払月の選択肢
     */
    getBonusTwiceMonthChoices() {
      if (this.editProductInputFieldes.bonusTwiceMonth) {
        // 初期表示時に「YYYY-MM-DD」の表記となってしまうのを防ぐため
        const isExist = this.editProductInputFieldes.bonusTwiceMonth.choices.some(x => x.value === this.form.bonus_twice_month)
        if (this.fixBonusMonth || (this.firstLoadFlg && !isExist)) {
          return this.editProductInputFieldes.bonusTwiceMonth.fixChoices
        } else {
          return this.editProductInputFieldes.bonusTwiceMonth.choices
        }
      } else {
        return []
      }
    },
    /**
     * シュミレーションで使用するアドオン率を取得
     */
    getAddon() {
      if (this.finances.length) {
        const result = this.finances.filter((fin) => fin.category_name === this.form.finance_category_name)
        return result.length ? result[0] : null
      } else {
        return null
      }
    },
    /**
     * 選択中の商品名を取得
     */
    selectedProductName() {
      const filter = this.products.filter((product) => product.id === this.form.product)
      if (!filter.length) return ''

      return filter[0].name
    }
  },

  watch: {
    fixBonusMonth: function (newVal, oldVal) {
      this.udpateBonusOnceMonth()
    },
    form: {
      async handler(newValue) {
        this.editProductInputFieldes = EditProductInputFieldes(
          this.has_payment,
          newValue,
          this.getAppDate,
          this.finances,
          this.options
        )
      },
      deep: true
    },
    finances: {
      async handler(newValue) {
        this.editProductInputFieldes = EditProductInputFieldes(this.has_payment, this.form, this.getAppDate, newValue, this.options)
      },
      deep: true
    }
  },
  methods: {
    back() {
      this.$confirm('変更を保存しますか？', '変更確認', {
        confirmButtonText: 'はい',
        cancelButtonText: '詳細画面へ',
        type: 'info'
      })
        .then(() => {
          this.contractUpdate()
        })
        .catch(() => {
          this.transitionSame('list-detail')
        })
    },
    setStoreFinanceId(financeCategoryName) {
      this.storeFinanceId = this.finances.find(fin => fin.category_name === financeCategoryName)?.id
      if(!this.storeFinanceId) {
        this.$message.error('金融商品情報が取得できませんでした。支払い方法を変更してください。')
        this.setStoreFinanceId(this.finances.find(x => x.is_initial).category_name)
      }
    },
    /**
     * 支払方法・アドオン月利カテゴリに対応する加盟店設定を this.options に設定する
     *
     * 支払開始月ルールだけは加盟店の現在設定ではなく、契約に焼き込まれた
     * 申込時点の値で上書きする。加盟店が設定を変更しても既存契約の
     * 支払開始月・ボーナス月の選択肢が変わらないようにするため。
     */
    setOptions() {
      const option = this.allOptions.find(
        option => option.has_payment === this.has_payment && option.store_finance_id === this.storeFinanceId
      )
      this.options = option
        ? {...option, use_new_payment_start_rule: readUseNewPaymentStartRule(this.contract)}
        : option
    },
    /**
     * 契約を取得する処理
     */
    getContract() {
      return new Promise((resolve) => {
        axios
          .get(`/api/store/contract/${this.$route.params.id}`)
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    /**
     * 金融商品を取得する処理
     */
    getFinances() {
      return new Promise((resolve) => {
        axios
          .get('/api/store/store/finances')
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    /**
     * 加盟店の設定を取得する処理
     */
    getOptions() {
      return new Promise((resolve) => {
        axios
          .get('/api/store/store/option')
          .then((res) => {
            // res.data = res.data.find(x => x.has_payment === this.has_payment && x.store_finance_id === this.storeFinanceId)     // 該当するステータスに絞り込む
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    /**
     * 商品一覧を取得
     */
    getProducts() {
      return new Promise((resolve) => {
        axios
          .get('/api/store/store/products')
          .then((res) => {
            const result = []
            if (res.data) {
              for (let key in res.data) {
                if (res.data[key].is_active && !res.data[key].is_use_credit) result.push(res.data[key])
              }
            }
            resolve(result)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    /**
     * バリデーションのルールをレスポンス
     */
    returnValidationRules() {
      const uniqueRule = this.has_payment === 'credit' ? ValidationRulesCredit : ValidationRulesInstallment
      if(ValidationRulesCommon.split_number.some(x => x.key === 'split_number_between')) {
        const betweenRule = ValidationRulesCommon.split_number.find(x => x.key === 'split_number_between')
        betweenRule.rule = `between:${this.options.split_lower_limit},${this.options.split_limit},回`
      } else {
        ValidationRulesCommon.split_number.push({
          key: 'split_number_between',
          rule: `between:${this.options.split_lower_limit},${this.options.split_limit},回`,
          event: 'blur,change'
        })
      }
      return ValidationRulesFun(ValidationRulesCommon, uniqueRule)
    },

    /**
     * 商品の値変更処理
     */
    onChangeProduct() {
      const filter = this.products.filter((product) => product.id === this.form.product)
      if (!filter.length) {
        this.form.service_start_date = null
        this.form.service_end_date = null
        return
      }
      if (filter[0].name !== 'その他') this.form.product_other_name = ''
    },
    /**
     * 金融カテゴリーが変更があった場合
     */
    onChangeFinanceCategoryName() {
      const initNull = [
        'payment',
        'split_number',
        'bonus_combined_addition_amount',
        'bonus_combined_month1',
        'bonus_combined_month2',
        'bonus_combined_number',
        'bonus_once_month',
        'bonus_twice_month',
        'payment_amount_once',
        'payment_amount_second',
        'split_fee',
        'split_total_payment',
        'total_pay',
        // 'person_charge',         // 担当者 フルネーム
        'payment_period_start',
        'payment_period_end'
      ]
      // 初期化値がnull
      initNull.map((item) => {
        this.form[item] = null
      })
      this.formExtends = {}

      // オプション項目の再設定
      this.setStoreFinanceId(this.form.finance_category_name)
      this.setOptions()

      // 分割回数のバリデーションを動的に変更するために定義
      validate(this.returnValidationRules(), true, this.has_payment)

      removeError('finance_category_name', 'exists')
    },
    /**
     * ボ２回払いの金額修正
     */
    editSecondPayment() {
      this.fixSecondPayment = true
    },

    /**
     * ボ２回払いの金額修正時の自動計算
     */
    changeSecondPayment() {
      if (!this.form.cash_total || !this.form.down_payment) {
        return
      }
      this.form.payment_amount_second =
        helper.helperNoneComma(this.form.split_total_payment) - helper.helperNoneComma(this.form.payment_amount_once)
    },

    /**
     * 支払い開始日（年）の日付を取得
     */
    getPaymentPeriodStartYearList() {
      return EditProductInputOptionConstants.peymentPeriodYears(this.getAppDate.year())
    },

    /**
     * 支払い開始日（月）disabled制御
     */
    isPaymentPeriodStartMonthEnable(item) {
      const y = this.formExtends.payment_period_start_y ? this.formExtends.payment_period_start_y : this.getAppDate.year()
      const m = item.value

      // ❶支払方法 分割払い or 分割またはボーナス併用 + 翌月可能なフラグが設定されている
      // ❷支払方法 マンスリークリア + 翌月可能なフラグが設定されている
      const isBorderRuleEnabled =
        (this.form.payment === 'split' && this.options.setting_split_bonus_start_period) ||
        (this.form.payment === 'split_bonus' && this.options.setting_split_bonus_start_period) ||
        (this.form.payment === 'monthly' && this.options.setting_monthly_start_period)

      // 選択を受け付ける最短の月(申込月からの加算月)
      // フラグON : 区切り日(10日)以内なら【翌月】から、超過なら【翌々月】から
      // フラグOFF: 現行ルールなら【翌々月】から、新ルールなら【翌月】から
      const minAddMonth = startPeriodAddMonth(this.getAppDate, isBorderRuleEnabled, this.useNewPaymentStartRule)

      // if (this.options.is_koihada && d <= 10) {
      //   return this.getAppDate.isSameOrAfter(y + '-' + m + '-' + '27', 'month')
      // }

      // 最短月より手前に寄せてから申込月と比較する(申込月以前になる月をdisabledにする)
      const targetMoment = moment(`${y}-${m}-27`, 'YYYY-M-DD').subtract(minAddMonth - 1, 'month')

      return this.getAppDate.isSameOrAfter(targetMoment, 'month')
    },

    /**
     * 支払い開始日項目 disabled制御
     */
    isPaymentPeriodStartFieldDisable() {
      // 支払い方法 分割またはボーナス併用、マンスリークリア以外はdisable
      // const passedPayments = ['split', 'split_bonus', 'monthly']
      // if (!passedPayments.includes(this.form.payment)) return true


      // // // 支払い方法 分割またはボーナス併用以外はdisable
      // // const passedPayments = ['split', 'split_bonus']
      // // if (!passedPayments.includes(this.form.payment)) {
      // //   return true
      // // }

      // // 支払い方法 分割またはボーナス併用、マンスリークリアの場合
      // if(this.form.payment === 'split' || this.form.payment === 'split_bonus' || this.form.payment === 'monthly') {
      //   return true
      // }
      // 支払い方法 マンスリークリアの場合
      // if(this.form.payment === 'monthly') {
      //   if(yearflg) return true
      //   return !this.options.setting_monthly_start_period
      // }

      // 加盟店ごとに契約設定を可能とする改修要望により結果的に全てdisabledの運用となったため。
      return true
    },

    /**
     * 支払い開始日の日付を更新して終了日を計算
     */
    generatePaymentPeriodStart() {
      const momentDate = moment()
      const month = this.formExtends.payment_period_start_m ? this.formExtends.payment_period_start_m : this.getAppDate.month()
      let year = this.formExtends.payment_period_start_y ? this.formExtends.payment_period_start_y : this.getAppDate.year()
      // 年跨ぎが発生する場合(2023年12月と2024年1月で表示される場合) ※支払い開始月も固定になり不要となったため
      // if(
      //   this.getAppDate.month() === 10 && d <= 10 &&  // 申込月が11月で日にちが10日以前
      //   (this.form.payment === 'split' && this.options.setting_split_bonus_start_period) ||
      //   (this.form.payment === 'split_bonus' && this.options.setting_split_bonus_start_period) ||
      //   (this.form.payment === 'monthly' && this.options.setting_monthly_start_period)
      // ) {
      //   if(this.getAppDate.year() !== year && month === 12) this.formExtends.payment_period_start_y -= 1
      //   if(this.getAppDate.year() === year && month === 1) this.formExtends.payment_period_start_y += 1
      // }
      momentDate.year(
        year
      )
      momentDate.month(
        month - 1
      )
      momentDate.date(27)
      this.form.payment_period_start = helper.helperGetBusinessDay(momentDate).format('YYYY-MM-DD')
      this.ignitionEvent('change', 'payment_period_start')
      this.updatePaymentPeriodEnd()
    },
    splitPaymentPeriodStartYM() {
      if (!this.form.payment_period_start) {
        this.formExtends.payment_period_start_y = ''
        this.formExtends.payment_period_start_m = ''
      } else {
        const ymd = moment(this.form.payment_period_start)
        this.formExtends.payment_period_start_y = ymd.year()
        this.formExtends.payment_period_start_m = ymd.month() + 1
      }
    },

    /**
     * 支払方法項目より下の項目の値を初期化する処理
     * @param {object} e
     */
    changePayment(e) {
      const initNull = [
        'split_number',
        'bonus_combined_addition_amount',
        'bonus_combined_month1',
        'bonus_combined_month2',
        'bonus_combined_number',
        'bonus_once_month',
        'bonus_twice_month',
        'payment_amount_once',
        'payment_amount_second',
        'split_fee',
        'split_total_payment',
        'total_pay',
        // 'person_charge',         // 担当者 フルネーム
        'payment_period_start',
        'payment_period_end'
      ]
      // 初期化値がnull
      initNull.map((item) => {
        this.form[item] = null
      })

      this.formExtends = {}
      this.firstLoadFlg = false

      // バリデーション用のボーナス加算回数を初期化
      document.getElementById('bonus_combined_payment').value = null

      this.isPaymentPeriodStartYDisable = this.isPaymentPeriodStartFieldDisable()
      this.isPaymentPeriodStartMDisable = this.isPaymentPeriodStartFieldDisable()

      // change eventを強制発火
      this.ignitionEvent('change', 'payment')

      // 支払方法によって処理を変更
      switch (this.form.payment) {
        case 'once':
          this.fixSecondPayment = false
          // 支払月1回目の更新へ
          setTimeout(() => {
            this.udpateBonusOnceMonth()
          }, 10)
          break
        case 'seconds':
          // 支払月1回目の更新へ
          setTimeout(() => {
            this.udpateBonusOnceMonth()
          }, 10)
          break
        default:
          this.fixSecondPayment = false
          // 支払期間 開始の更新へ
          this.updatePaymentPeriodStart()
          break
      }
    },
    /**
     * 分割回数検索
     */
    querySearchSplitNumber(queryString, cb) {
      var select = this.editProductInputFieldes.splitNumber.choices
      var results = queryString ? select.filter(this.createFilterSplitNumber(queryString)) : select
      cb(results)
    },
    createFilterSplitNumber(queryString) {
      return (item) => {
        return item.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },

    /**
     * 分割回数・手入力時の値更新
     */
    updateSplitNumber(value) {
      if (value == null || value == '') {
        this.form.split_number = null
        return
      }
      if (!value.match(/^[0-9]+$/) || value.length > 3) {
        this.form.split_number = null
        return
      }
      this.form.split_number = value
      this.updatePaymentPeriodStart()
      this.ignitionEvent('change', 'split_number')
    },
    zeroDelete(form) {
      //金額欄0なら削除
      if (this.form[form]) {
        if (this.form[form] == 0) {
          this.form[form] = ''
        }
      }
    },

    /**
     * 現在価格合計と頭金が変更したときの処理
     * @param {string} type 項目タイプ
     */
    updateRemainigMoney(type) {
      // 頭金
      const down_payment = Number(String(this.form.down_payment).replace(/,/g, '')) | 0
      // 現在価格合計
      const cash_total = Number(String(this.form.cash_total).replace(/,/g, '')) | 0
      // 残金を計算
      this.form.remaining_money = cash_total - down_payment
      // this.isComma('remaining_money');
      this.ignitionEvent('blur', 'remaining_money')
      if (type === 'cash_total') {
        this.ignitionEvent('input', 'down_payment')
      }

      if (this.form.payment) this.simlation()
    },
    // 支払月1回目更新
    udpateBonusOnceMonth() {
      // 支払月1回目が変更になったときに支払月2回目の値がselectの値と同じのがなければ初期化される。
      if (this.getBonusOnceMonthChoices.length) {
        this.form.bonus_once_month = this.getBonusOnceMonthChoices[0].value

        // change event強制発火
        this.ignitionEvent('change', 'bonus_once_month')
      }

      // 支払月2回目の更新へ
      this.updateBonusSecondMonth()
    },
    // 支払月2回目更新
    updateBonusSecondMonth() {
      // 支払期間 開始の更新へ
      setTimeout(async () => {
        if (this.form.payment === 'seconds' && this.getBonusTwiceMonthChoices.length) {
          this.form.bonus_twice_month = this.getBonusTwiceMonthChoices[0].value

          // change event強制発火
          await this.ignitionEvent('change', 'bonus_twice_month')
          // const same = this.editProductInputFieldes.bonusTwiceMonth.choices.filter(month => month.value === this.form.bonus_twice_month);
          // if(!same.length) {
          // }
        }
        await this.updatePaymentPeriodStart()
      }, 10)
    },
    updatePaymentPeriodStart() {
      //　初回月の加算月数を決める
      // const monthly_month = 1;

      // 恋肌での月定義
      // const koihada_month =
      //   this.options.is_koihada && this.has_payment === 'installment' ? (this.getAppDate.date() < 11 ? 1 : 2) : 2

      // 支払い方法 分割払い or 分割またはボーナス併用、マンスリークリアの場合
      const isBorderRuleEnabled =
        (this.form.payment === 'split' && this.options.setting_split_bonus_start_period) ||
        (this.form.payment === 'split_bonus' && this.options.setting_split_bonus_start_period) ||
        (this.form.payment === 'monthly' && this.options.setting_monthly_start_period)

      // 支払開始月の月定義
      // フラグON : 区切り日(10日)以内なら翌月、超過なら翌々月
      // フラグOFF: 現行ルールなら翌々月固定、新ルールなら翌月固定
      const add_month = startPeriodAddMonth(this.getAppDate, isBorderRuleEnabled, this.useNewPaymentStartRule)


      // 引き落とし日
      const hikiotoshi_day = 27

      // 基準日
      const start =
        this.form.payment === 'monthly'
          ? moment().date(hikiotoshi_day).add(add_month, 'M').startOf('day').format('YYYY-MM-DD')
          : this.form.payment === 'once' || this.form.payment === 'seconds'
          ? this.form.bonus_once_month
            ? moment(this.form.bonus_once_month).date(hikiotoshi_day).startOf('day').format('YYYY-MM-DD')
            : null
          : moment().date(hikiotoshi_day).add(add_month, 'M').startOf('day').format('YYYY-MM-DD')

      // if(this.form.payment === 'once' || this.form.payment === 'seconds') {
      //     // 支払月1回目
      //     const once = moment(this.form.bonus_once_month).date(hikiotoshi_day).startOf('day')
      //     // 申込月
      //     const appMonth = this.getAppDate.clone().format('M');
      //     // ボーナス月
      //     const bonus = start.clone().month(once-1);

      //     if(appMonth == once && this.getAppDate.isBefore(bonus)) {
      //         this.form.payment_period_start = helper.helperConverDateJST(helper.helperGetBusinessDay(bonus));
      //     } else {
      //         this.form.payment_period_start = helper.helperConverDateJST(helper.helperGetBusinessDay(helper.helperGetbonusMonth(start,once)));
      //     }

      // } else {
      //     // ボーナス一括とボーナス二回以外
      // }
      // this.form.payment_period_start = helper.helperConverDateJST(helper.helperGetBusinessDay(start));
      this.form.payment_period_start = helper.helperGetBusinessDay(start).format('YYYY-MM-DD')
      this.splitPaymentPeriodStartYM()
      if (this.form.payment_period_start) this.updatePaymentPeriodEnd()
    },
    // 支払期間 終了更新
    updatePaymentPeriodEnd() {
      if (this.form.payment && this.form.payment_period_start) {
        // 基準日
        let standard = moment(this.form.payment_period_start).clone().startOf('day')
        // 引き落とし日
        const hikiotoshi_day = 27
        switch (this.form.payment) {
          case 'seconds':
            // 支払月2回目
            const seconds = moment(this.form.bonus_twice_month).format('M')
            if (!seconds) return

            // 基準日の年の支払月2回目を定義
            const secondsDate = standard
              .clone()
              .date(hikiotoshi_day)
              .month(seconds - 1)

            // 開始
            if (standard.isSameOrAfter(secondsDate)) {
              standard.date(hikiotoshi_day)
              // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(helper.helperGetbonusMonth(standard,seconds)));
              this.form.payment_period_end = helper
                .helperGetBusinessDay(helper.helperGetbonusMonth(standard, seconds))
                .format('YYYY-MM-DD')
            } else {
              // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(secondsDate));
              this.form.payment_period_end = helper.helperGetBusinessDay(secondsDate).format('YYYY-MM-DD')
            }
            break
          case 'split':
          case 'split_bonus':
            const count = Number(this.form.split_number) - 1
            if (count <= 0) return
            standard.date(hikiotoshi_day).add(count, 'M')
            // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(standard));
            this.form.payment_period_end = helper.helperGetBusinessDay(standard).format('YYYY-MM-DD')
            break
          default:
            // this.form.payment_period_end = helper.helperConverDateJST(helper.helperGetBusinessDay(standard));
            this.form.payment_period_end = helper.helperGetBusinessDay(standard).format('YYYY-MM-DD')
            break
        }
      }
      this.simlation()
    },

    // お支払いの金額の計算処理
    simlation() {
      // アドオン取得
      const addon = this.getAddon
      if (!addon) return

      // 残金が無いとき処理をさせない
      if (this.form.remaining_money == null || this.form.remaining_money === '') return

      // 残金
      let total = Number(String(this.form.remaining_money).replace(/,/g, ''))

      let sim

      // 分割回数
      const count = Number(this.form.split_number)

      switch (this.form.payment) {
        case 'split':
          if (!count) return
          sim = splitPay(total, count, Number(addon.split_addon))
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.payment_amount_second = sim.paymentAmountSecond
          this.form.split_fee = sim.fee
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          break
        case 'split_bonus':
          if (
            !count ||
            !this.form.bonus_combined_addition_amount ||
            (!this.form.bonus_combined_month1 && !this.form.bonus_combined_month2)
          )
            return

          // 分割回数の回数分指定したボーナス月がどれだけあるか調べる処理
          const addition_amount = helper.helperNoneComma(this.form.bonus_combined_addition_amount)
          const month1 = this.form.bonus_combined_month1
          const month2 = this.form.bonus_combined_month2
          const payment_period_start = this.form.payment_period_start

          sim = splitBonusPay(
            total,
            count,
            addition_amount,
            month1,
            month2,
            payment_period_start,
            Number(addon.split_bonus_addon)
          )
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.payment_amount_second = sim.paymentAmountSecond
          this.form.bonus_combined_number = sim.bonusCombinedNumber
          this.form.split_fee = sim.fee
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          document.getElementById('bonus_combined_payment').value = addition_amount * sim.bonusCombinedNumber
          this.ignitionEvent('blur', 'bonus_combined_payment')
          break
        case 'once':
          sim = oncePay(total, Number(addon.once_addon), false)
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          this.form.split_fee = sim.fee
          break
        case 'seconds':
          if (this.form.bonus_twice_month) {
            sim = secondsPay(total, Number(addon.seconds_addon), false)

            /**
             * 金額修正フラグがONの場合は変更しても再計算方法を変更
             */
            if (this.fixSecondPayment === true) {
              this.form.payment_amount_second = sim.total - helper.helperNoneComma(this.form.payment_amount_once)
            } else {
              this.form.payment_amount_once = sim.paymentAmountOnce
              this.form.payment_amount_second = sim.paymentAmountSecond
            }

            this.form.split_total_payment = sim.total
            this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
            this.form.split_fee = sim.fee
          }
          break
        case 'monthly':
          sim = monthlyPay(total, Number(addon.once_addon), false)
          this.form.payment_amount_once = sim.paymentAmountOnce
          this.form.split_total_payment = sim.total
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          break
        default:
          this.form.payment_amount_once = total.toLocaleString()
          this.form.split_total_payment = total.toLocaleString()
          this.form.total_pay = sim.total + helper.helperNoneComma(this.form.down_payment)
          break
      }
    },

    /**
     * 支払い金額のバリデーション
     */
    validatePaymentAmountSecond() {
      if(this.form.payment === 'seconds') {
        const reqErrorEl = document.querySelector('.error-payment_amount_second-limit')
        reqErrorEl.innerHTML = ''
        const header = reqErrorEl.closest('.js_error').querySelector('.js_error_header')
        header.classList.remove(`is_active_payment_amount_second_limit`)
        if(this.form.payment_amount_second < 1) {
          reqErrorEl.innerHTML = '支払金額の2回目以降は必ず0円以上の金額が必要です。'
          header.classList.add(`is_active_payment_amount_second_limit`)
        }
      }
    },

    contractUpdate() {
      this.isUpdateBtnPushed = true
      const loadingItem = Loading.service({})
      // バリデーションチェック
      const validationRules = this.returnValidationRules()
      for (let key in validationRules) {
        validationRules[key].map(async (validation) => {
          if (validation.rule.match('message_custom')) document.getElementById(key).value = true
          await this.ignitionEvent(validation.event, key)
        })
      }
      // 支払い回数2回目のバリデーション実行
      this.validatePaymentAmountSecond()

      setTimeout(() => {
        let errors = document.querySelectorAll('.error_message')
        let error_class = ''
        for (var i = 0; i < errors.length; i++) {
          if (errors[i].innerHTML) {
            error_class = errors[i].className
            break
          }
        }
        if (error_class) {
          helper.helperSmoothScroll(error_class, true)
          this.$message.error('入力に不備があります。入力内容をご確認ください。')
        } else {
          const copy = _.cloneDeep(this.form)
          // 強制的に顧客情報を変更
          axios
            .put(
              '/api/store/contract/' + this.$route.params.id,
              this.valueConversion(EditProductInputOptionConstants.Conversions, false, copy)
            )
            .then((res) => {
              this.$message(`商品情報　更新完了`)
              this.transitionSame('list-detail')
            })
            .catch((err) => {
              console.log(err, err.response.data)
              if(err.response.status === 422) {
                this.$message.error('入力に不備があります。入力内容をご確認ください。')
              } else {
                this.$message.error('送信に失敗しました。入力内容をご確認ください。')
              }
              if (err.response.data) {
                const error_validations = []
                for (let key in err.response.data) {
                  err.response.data[key].map((item) => {
                    let terms = item.split(':')
                    const obj = {
                      rule: terms[0],
                      message: terms[1],
                      key: key
                    }
                    error_validations.push(obj)
                  })
                }
                error_validations.map((validate) => {
                  setErrorLaravel(validate.key, validate.rule, validate.message, true)
                })
                setTimeout(() => {
                  errors = document.querySelectorAll('.error_message')
                  error_class = ''
                  for (var i = 0; i < errors.length; i++) {
                    if (errors[i].innerHTML) {
                      error_class = errors[i].className
                      break
                    }
                  }
                  if (error_class) {
                    helper.helperSmoothScroll(error_class, true)
                  }
                }, 100)
              }
            })
        }
      }, 500)
      this.isUpdateBtnPushed = false
      loadingItem.close()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/_variables.scss';
.head_data {
  text-align: center;
  font-size: 18px;
  border-bottom: 1px solid#eee;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.camera {
  padding-top: 40px;

  .delete {
    opacity: 0.3;
  }

  &__item {
    width: 28%;
    height: 22vw;
    margin-bottom: 40px;
    border: 1px solid #d3d3d3;
    border-radius: 10px;
    padding: 5px;
    &:nth-child(3n + 1) {
      margin-left: 4%;
    }
    &:nth-child(3n - 1) {
      margin-left: 4%;
      margin-right: 4%;
    }
    &--inner {
      border: 1px solid #d3d3d3;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 5px;
      & a {
        text-align: center;
        display: inline-block;
      }
      & img {
        max-width: 90%;
        max-height: 21vw; // 規定の高さを入れる（可変）
        height: auto;
        vertical-align: bottom;
      }
    }
    &--add {
      border: 1px solid $--color-primary;
      & .camera__item--inner {
        background-color: #f8f8f8;
      }
    }
  }
  &__icon {
    font-size: 6vw;
  }
  &__txt {
    font-size: 2.5vw;
    margin: 0;
  }
}
.modal {
  &-wrap {
    width: 100%;
    height: 80vh;
    position: relative;
    & img {
      max-width: 100%;
      max-height: 80vh;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &__img {
    position: relative;
    & i {
      position: absolute;
      bottom: 5px;
      right: 5px;
      font-size: 3vw;
      cursor: pointer;
    }
  }
}

::v-deep .table_block {
  .price_input {
    &__left {
      input {
        &.el-input__inner {
          text-align: left;
        }
      }
    }
  }
  .select {
    &--w120 {
      width: 120px;
    }
    &--w90 {
      width: 90px;
    }
  }
}
</style>
